import React from "react";
import { useTranslation } from "react-i18next";
import DialogActionButton from "./DialogActionButton";

interface PromptDialogProps {
  title: string;
  message?: string | React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

const PromptDialog: React.FC<PromptDialogProps> = ({
  title,
  message,
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
  confirmButtonClass = "",
  isLoading = false,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black/50 p-4">
      <div className="z-[100] w-full max-w-[680px] overflow-hidden rounded-[4px] bg-white shadow-[0_16px_40px_rgba(0,0,0,0.28)]">
        <div className="bg-[#F24848] px-6 py-4 text-center text-xl font-semibold text-white">
          {title}
        </div>

        <div className="space-y-6 px-8 py-7">
          {message && (
            <div>
              {typeof message === "string" ? (
                <p className="whitespace-pre-wrap text-center text-sm text-[#333333]">
                  {t(message)}
                </p>
              ) : (
                message
              )}
            </div>
          )}

          {children}

          <div className="grid grid-cols-2 gap-4">
            <DialogActionButton
              onClick={onCancel}
              variant="danger-secondary"
              disabled={isLoading}
              label={cancelText || t("_generic._cancel")}
            />

            <DialogActionButton
              onClick={onConfirm}
              className={confirmButtonClass}
              disabled={isLoading}
              loading={isLoading}
              variant="danger"
              label={confirmText || t("_generic._yes")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptDialog;
